import { styled } from "@mui/material/styles";
import { VariantType } from "notistack";
import { Colors } from '../../../constants';

interface CoreToastBodyProps {
	variant: VariantType;
}

export const CoreToastBody = styled('div')<CoreToastBodyProps>(({ theme }) => ({
	position: 'relative',
	padding: '12px 16px',
	minWidth: '343px',
	borderRadius: theme.shape.borderRadius,
	backgroundColor: '#2A2A2A',
	width: '100%',
	display: 'flex',
	border: `1px solid ${Colors.transparent}`,
	fontSize: '15px',
	fontWeight: 600,
	gap: '16px',
}));
